<div fxLayout="column"
  *ngIf="this.serviceLaneFacade.oemDashboardData$ | async as fordDashboardData; else dashboardLoading">
  <div *ngIf="fordDashboardData.error === null">
    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;margin-top: 24px;"
      fxLayoutAlign="space-between center">
      <h2>Outstanding Field Service Actions</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(outstandingFieldServiceActionsUi)">
        <mat-icon>{{outstandingFieldServiceActionsUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!outstandingFieldServiceActionsUi.collapsed">
      <div class="alerts-container py-0 mx-4" id="alertsContainer"
        *ngIf="fordDashboardData?.dashboardJson?.ServiceCampaign?.Campaign?.length > 0; else noCampaigns">
        <div fxLayout="column" class="alert-block"
          *ngFor="let alert of fordDashboardData?.dashboardJson?.ServiceCampaign?.Campaign">
          <div class="flex row mb-1" fxLayoutAlign="start center">
            <div fxLayoutAlign="center center" [ngClass]="'danger'">
              <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
            </div>
            <span class="font-medium ml-2 text-base"> {{alert?.CampaignId}} </span>

          </div>
          <div fxLayoutAlign="start start" class="pl-8">
            <span class="primary-bullet">·</span>
            <span>{{alert?.CampaignDescription}} </span>
          </div>
        </div>
      </div>
      <ng-template #noCampaigns>
        <div class="mb-4">
          <span class="mat-body-1 pl-4" data-cy='no-campaigns-span'>No outstanding field service actions</span>
        </div>
      </ng-template>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>General Warranty</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(generalWarrantyUi)">
        <mat-icon>{{generalWarrantyUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!generalWarrantyUi.collapsed">
      <div class="alerts-container py-0 px-4" id="alertsContainer"
        *ngIf="fordDashboardData?.dashboardJson?.Warranty; else noWarrantyInfo">
        <div class="flex flex-col alert-block">
          <div class="flex flex-row mb-1" fxLayoutAlign="start center">
            <div fxLayoutAlign="center center" class="info">
              <mat-icon class="text-3xl pb-1" fxLayoutAlign="center center">info</mat-icon>
            </div>
            <span class="font-medium ml-2 text-base"> Warranty Start Date:
              {{fordDashboardData?.dashboardJson?.Warranty?.StartDate?._text}} </span>

          </div>
          <div fxLayoutAlign="start start" class="pl-8">
            <span class="primary-bullet">·</span>
            <span>Build Date: {{fordDashboardData?.dashboardJson?.Warranty?.BuildDate?._text}} </span>
          </div>
        </div>
      </div>
      <ng-template #noWarrantyInfo>
        <div class="mb-4">
          <span class="mat-body-1 pl=4" data-cy='no-warranty-info-span'>No warranty information</span>
        </div>
      </ng-template>
    </ng-container>


    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Warning Messages</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(warningMessagesUi)">
        <mat-icon>{{warningMessagesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!warningMessagesUi.collapsed">
      <div class="alerts-container py-0 px-4" id="alertsContainer"
        *ngIf="fordDashboardData?.dashboardJson?.Warranty?.WarrantyMessage && fordDashboardData?.dashboardJson?.Warranty?.WarrantyMessage?.length > 0; else noWarrantyMessages">
        <div class="flex flex-col alert-block"
          *ngFor="let warrantyMessage of fordDashboardData?.dashboardJson?.Warranty?.WarrantyMessage | groupBy: '_attributes.Type' | pairs">
          <div class="flex flex-row mb-1" fxLayoutAlign="start center">
            <div fxLayoutAlign="center center" [ngClass]="'warning'">
              <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
            </div>
            <span class="font-medium ml-2 text-base"> {{getWarningTitle(warrantyMessage[0])}}
            </span>

          </div>
          <div fxLayoutAlign="start start" class="pl-8" *ngFor="let message of warrantyMessage[1]">
            <span class="primary-bullet">·</span>
            <span>{{message?._text}} </span>
          </div>
        </div>
      </div>

      <ng-template #noWarrantyMessages>
        <div class="mb-4">
          <span class="mat-body-1 pl-4" data-cy='no-warranty-messages-span'>No warranty messages found</span>
        </div>
      </ng-template>
    </ng-container>


    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Extended Coverages</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(extendedCoveragesUi)">
        <mat-icon>{{extendedCoveragesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!extendedCoveragesUi.collapsed">
      <div class="alerts-container py-0 px-4" id="alertsContainer"
        *ngIf="fordDashboardData?.dashboardJson?.ServiceContract && fordDashboardData?.dashboardJson?.ServiceContract?.length > 0; else noExtendedCoverage">
        <div class="flex flex-col alert-block"
          *ngFor="let serviceContract of fordDashboardData?.dashboardJson?.ServiceContract">
          <div class="flex flex-row mb-1" fxLayoutAlign="start center">
            <div fxLayoutAlign="center center" class="info">
              <mat-icon class="text-3xl pb-1" fxLayoutAlign="center center">info</mat-icon>
            </div>
            <span class="font-medium ml-2 text-base"> {{serviceContract?.ContractPlanCode?._text}} -
              {{serviceContract?.ContractPlanDescription?._text}} </span>

          </div>
          <div fxLayoutAlign="start start" class="pl-8">
            <span class="primary-bullet">·</span>
            <span>Contract ends on {{serviceContract?.ContractEnd?._text}} and is owned by
              {{serviceContract?.ContractOwner?._text}} with a term mileage of
              {{serviceContract?.ContractTermMileage?._text}}</span>
          </div>
          <div fxLayoutAlign="start start" class="pl-8">
            <span class="primary-bullet">·</span>
            <span>Towing allowance of {{serviceContract?.ContractTowing?._text}} and rental allowance of
              {{serviceContract?.ContractRental?._text}}</span>
          </div>
          <h4>Notes</h4>
          <div fxLayoutAlign="start start" class="pl-8" *ngFor="let note of serviceContract?.DetailMessage">
            <span class="primary-bullet">·</span>
            <span>{{note?._text}}</span>
          </div>
        </div>
      </div>
      <ng-template #noExtendedCoverage>
        <div style="margin-bottom: 16px;">
          <span class="mat-body-1 pl-4" data-cy='no-ext-coverage-span'>No extended coverage found</span>
        </div>
      </ng-template>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Warranty Repair History</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(warrantyRepairHistoryUi)">
        <mat-icon>{{warrantyRepairHistoryUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>


    <ng-container *ngIf="!warrantyRepairHistoryUi.collapsed">
      <div class="alerts-container py-0 px-4" id="alertsContainer"
        *ngIf="fordDashboardData?.dashboardJson?.ServiceHistory?.Service && fordDashboardData?.dashboardJson?.ServiceHistory?.Service.length > 0;else noRepairHistory">
        <div fxLayout="column" class="alert-block"
          *ngFor="let service of fordDashboardData?.dashboardJson?.ServiceHistory.Service">
          <div class="flex flex-row mb-1" fxLayoutAlign="start center">
            <div fxLayoutAlign="center center" class="info">
              <mat-icon class="text-3xl pb-1" fxLayoutAlign="center center">info</mat-icon>
            </div>
            <span class="font-medium ml-2 text-base"> {{service.RepairOrderCompletedDate._text}} -
              {{service.DealerName._text}} - Claim#{{service.DocumentId._text}} </span>

          </div>
          <ng-container *ngIf="isArray(service.Job); else singleServiceJob">
            <div fxLayoutAlign="start start" class="pl-8" *ngFor="let job of service.Job">
              <span class="primary-bullet">·</span>
              <span><b>{{job.ServiceParts.ItemQuantity._text}}x</b> Part Number <b>{{job.ServiceParts.ItemId._text}}</b>
                ({{job.ServiceParts?.ItemDescription?._text ? job.ServiceParts?.ItemDescription?._text
                : 'no part description provided'}})</span>
            </div>
          </ng-container>
          <ng-template #singleServiceJob>
            <div fxLayoutAlign="start start" class="pl-8">
              <span class="primary-bullet">·</span>
              <span><b>{{service.Job.ServiceParts.ItemQuantity._text}}x</b> Part Number
                <b>{{service.Job.ServiceParts.ItemId._text}}</b>
                ({{service.Job.ServiceParts?.ItemDescription?._text ? service.Job.ServiceParts?.ItemDescription?._text :
                'no part description provided'}})</span>
            </div>
          </ng-template>


        </div>
      </div>
      <ng-template #noRepairHistory>
        <div class="mb-4">
          <span class="mat-body-1 pl-4" data-cy='no-repair-history-span'>No warranty history found</span>
        </div>
      </ng-template>
    </ng-container>




  </div>
</div>


<ng-template #dashboardLoading>
  <ng-container fxLayout="column">
    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;margin-top: 24px;">
      <h2>Outstanding Field Service Actions</h2>
    </div>
    <div class="alerts-container py-0 px-4" id="alertsContainer">
      <div class="flex flex-col alert-block">
        <div class="flex flex-row mb-1" fxLayoutAlign="start center">

          <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
          </div>
          <span class="h-4 w-1/3 my-1.5 mr-0 ml-2 rounded animated-background"></span>



        </div>
        <div fxLayoutAlign="start start" class="pl-8">
          <span class="h-4 w-1/5 my-1.5 mr-0 ml-2 rounded animated-background"></span>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>General Warranty</h2>
    </div>
    <div class="flex flex-col alerts-container py-0 px-4" id="onStarContainer" fxLayout="column">
      <div class="flex flex-col alert-block">
        <span class="font-medium text-base mb-2">Status</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" xLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>

      <div class="flex flex-col alert-block">

        <div class="mb-2">
          <span class="animated-background h-4 w-1/3 my-1.5 mr-0 ml-1 rounded"></span>
          <span class="font-medium text-base mb-2">Tires</span>
        </div>

        <div fxLayout="row wrap">

          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>

            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="alert-block flex flex-col">
        <span class="font-medium text-base mb-2">XM Radio Information</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
          <div class="mb-1 flex flex-row" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>

      <div class="flex flex-col alert-block">
        <span class="font-medium text-base mb-2">Other</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2"></span>
          </div>

          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Warning Messages</h2>
    </div>

    <div class="py-0 px-4" id="claimsHistoryContainer">
      <div class="flex flex-col w-full result-container">
        <div fxLayoutAlign="space-between center" class="result-header-container">
          <div class="flex flex-col w-full">
            <div class="flex flex-row w-full" fxLayoutAlign="start center">
              <span class="animated-background h-5 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
            </div>
            <span class="animated-background h-4 w-1/3 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="flex flex-col result-content-container">
          <div class="flex flex-col">
            <div class="flex flex-col w-full">
              <div class="flex flex-row pb-5" fxLayoutAlign="start start">
                <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl"></div>
                <div class="flex flex-col">
                  <div fxLayoutAlign="start start">
                    <span class="animated-background h-4 w-4/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
                  </div>
                  <div class="flex flex-col">
                    <div class="flex flex-col text-grey-800">
                      <div fxLayoutAlign="start center">
                        <div class="animated-background h-1 w-1 my-1.5 mr-0 ml-2 rounded-sm"></div>
                        <span class="animated-background h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>